import React, { Fragment, useEffect, useState } from 'react';
import Helmet from 'react-helmet';
import { connect } from 'react-redux';
import { Creators as TaskCreators } from 'store/ducks/task';
import { Creators as ChatCreators } from 'store/ducks/chat';

import Section from 'components/Section';

import { Route, Link } from 'react-router-dom';

import leftIcon from 'assets/img/icons/goBack.svg';
import downloadIcon from 'assets/img/icons/download.svg';
import { getLabels } from 'services/api/labels';

import { gaSendEvent } from '../../utils/analytics';

import OrderTab from './Tabs/OrderTab';
import DocumentTab from './Tabs/DocumentTab';
import DetailsTab from './Tabs/DetailsTab';
import ReportTab from './Tabs/ReportTab';
import CommentsTab from './Tabs/CommentsTab';

import DownloadReportModal from './DownloadReportModal';
import SideMenu from './SideMenu';

import SEGMENTS from '../../helpers/segment';

import {
  Header,
  DetailsCard,
  Tabs,
  ServiceName,
  Label,
  DownloadButton,
  WrapperTab,
  NavLink,
  Container,
  StyledLink,
  ContentTab,
} from './styles';

const TaskDetailsRoutes = ({ url, taskDetail, optionsLabel }) => (
  <WrapperTab>
    <ContentTab>
      <Route path={`${url}/orcamentos`} component={OrderTab} />
      <Route path={`${url}/detalhes`} component={DetailsTab} />
      <Route path={`${url}/comentarios`} component={CommentsTab} />
      <Route
        path={`${url}/nota-fiscal`}
        component={() => <DocumentTab paymentTicket={taskDetail.taskNfs} />}
      />
      <Route
        path={`${url}/pagamento`}
        component={() => <DocumentTab invoice={taskDetail.taskPaymentTicket} />}
      />
      <Route path={`${url}/reportar-problema`} component={ReportTab} />
    </ContentTab>
    <div style={{ float: 'right', width: '70px' }}>
      <SideMenu options={optionsLabel} />
    </div>
  </WrapperTab>
);

const TaskDetails = ({
  match,
  taskDetail,
  company,
  loadingVisible,
  isAdmin,
  commentsSize,
  _getComments,
  _getTaskDetail,
  _getCancelTaskOptions,
  _initChat,
  _removeChats,
}) => {
  const { taskId } = match.params;

  const [modalVisible, setModalVisible] = useState(false);
  const [optionsLabel, setOptionsLabel] = useState([]);

  const getLabelsFilter = async () => {
    const data = await getLabels();
    if (data.success) {
      setOptionsLabel(data.labels);
    }
  };


  useEffect(() => {
    _getTaskDetail(taskId);
    getLabelsFilter();
  }, []);

  useEffect(() => {
    if (taskId) {
      _getComments({ taskId });
    }
  }, [taskId]);

  useEffect(() => {
    _getCancelTaskOptions(taskDetail);
  }, [taskDetail.status]);

  useEffect(() => {
    if (taskDetail.quotes && taskDetail.quotes.length > 0) {
      taskDetail.quotes.forEach((q) => {
        if (q.chat_id) _initChat(q.chat_id);
      });
    }

    return () => _removeChats();
  }, [taskDetail.id]);

  const openDownloadModal = () => {
    gaSendEvent('baixar_resumo', 'detalhes_pedido');
    setModalVisible(true);
  };

  return (
    <Section color="#FBFBFB">
      <Helmet title="Triider - Detalhes do pedido" />
      <Container>
        <Header>
          <StyledLink to={{ pathname: '/pedidos', ofBack: true }}>
            <img src={leftIcon} alt="Left Icon" />
            <span className="label-back">Voltar</span>
          </StyledLink>
          {taskDetail && !loadingVisible && (
            <ServiceName isAdmin={isAdmin}>
              {taskDetail.service_name}
              {isAdmin
                ? (
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={`${process.env.BO_PATH}/task/${taskDetail.id}`}
                  >
                    <span>
                      &nbsp;
                      #
                      {taskDetail.id}
                    </span>
                  </a>
                )
                : (
                  <span>
                    &nbsp;
                    #
                    {taskDetail.id}
                  </span>
                )
              }
              {taskDetail.status === 'canceled' && <Label color="red">Cancelado</Label>}
            </ServiceName>
          )}
        </Header>
        <DetailsCard>
          <Tabs>
            <NavLink to={`${match.url}/orcamentos`} activeClassName="active">
              Orçamentos
            </NavLink>
            <NavLink to={`${match.url}/detalhes`} activeClassName="active">
              Detalhes do pedido
            </NavLink>
            <NavLink to={`${match.url}/comentarios`} activeClassName="active">
              Comentários (
              {commentsSize}
              )
            </NavLink>
            {taskDetail
            && taskDetail.taskPaymentTicket
            && taskDetail.taskPaymentTicket.length > 0 ? (
              <NavLink to={`${match.url}/pagamento`} activeClassName="active">
                Pagamento
              </NavLink>
              ) : (
                <NavLink to="#" title="Este pedido ainda não possui boleto" disabled>
                  Pagamento
                </NavLink>
              )}
            {taskDetail && taskDetail.taskNfs && taskDetail.taskNfs.length > 0 ? (
              <NavLink to={`${match.url}/nota-fiscal`}>Nota fiscal</NavLink>
            ) : (
              <NavLink to="#" title="Este pedido ainda não possui nota fiscal" disabled>
                Nota fiscal
              </NavLink>
            )}
            <NavLink to={`${match.url}/reportar-problema`} activeClassName="active">
              Reportar problema
            </NavLink>

            {(company.segment_id === SEGMENTS.IMOBILIARIA || company.segment_id === null) && !loadingVisible && (
              <DownloadButton
                onClick={() => openDownloadModal()}
                type="button"
                size="small"
                iconLeft={downloadIcon}
              >
                Baixar resumo
              </DownloadButton>
            )}
          </Tabs>
          <TaskDetailsRoutes optionsLabel={optionsLabel} url={match.url} taskDetail={taskDetail} />
        </DetailsCard>
        {!loadingVisible && modalVisible && (
          <DownloadReportModal
            isOpen={modalVisible}
            setModalVisible={setModalVisible}
            taskDetail={taskDetail}
            company={company}
          />
        )}
      </Container>
    </Section>
  );
};

const mapStateToProps = state => ({
  taskDetail: state.task.taskDetail,
  company: state.auth.triiderUser.company,
  isAdmin: state.auth.triiderUser.user.is_admin,
  commentsSize: state.task.commentsSize,
  loadingVisible: state.ui.loaders.includes('TASK_DETAIL'),
});

const mapDispatchToProps = {
  _getComments: TaskCreators.getCommentsRequest,
  _getTaskDetail: TaskCreators.getTaskDetailRequest,
  _getCancelTaskOptions: TaskCreators.getCancelTaskOptionsRequest,
  _initChat: ChatCreators.initChatRequest,
  _removeChats: ChatCreators.removeChats,
};

export default connect(mapStateToProps, mapDispatchToProps)(TaskDetails);
